/**
 * Konfigurationswerte. `PATCH /api/config/:key` ist aus Phase 1 BEKANNT UND STABIL
 * (`backend/src/http/routes/config.ts`) und zugleich der EINZIGE heute gebaute Endpunkt mit
 * optimistischer Versionspruefung - er ist damit das Vorbild, an dem sich die Domaenen-Endpunkte
 * aus Phase 4a messen lassen: `rowVersion` im Koerper, 409 mit `current` im Fehlerkoerper,
 * SSE-Broadcast mit `entity: "config"` nach der Antwort.
 *
 * DIE ANNAHME IST GEFALLEN (2026-08-14): `GET /api/config/:key` ist gebaut
 * (`backend/src/http/routes/config.ts`). Bis dahin registrierte `createConfigRouter` ausschliesslich
 * `patch`, und `konfigurationLesen` lief bei JEDEM Schluessel ins Leere - im Betrieb sichtbar als
 * 404 auf `/api/config/boardColumns` bei jedem Seitenaufbau. Die Funktion unten bleibt unveraendert
 * richtig; nur ihre Vorbedingung stimmt jetzt.
 *
 * Das Lesen verlangt KEIN `manage_settings` (anders als PATCH) - siehe Begruendung an der Route.
 */
import { anfrage, anfrageOderNull } from "./basis.ts";

export interface Konfigurationswert {
  key: string;
  rowVersion: number;
  value: unknown;
  updatedAt: string | null;
  updatedBy: string | null;
}

/** `null` bei unbekanntem Schluessel (404) - die erwartete Antwort, nicht ein Fehlerfall. */
export function konfigurationLesen(
  key: string,
  signal?: AbortSignal,
): Promise<Konfigurationswert | null> {
  return anfrageOderNull<Konfigurationswert>(`/api/config/${encodeURIComponent(key)}`, { signal });
}

/**
 * Schreibt einen Konfigurationswert. `rowVersion` ist der zuletzt GELESENE Stand; stimmt er nicht
 * mehr, wirft `basis.ts` einen `KonfliktFehler` mit dem aktuellen Serverstand.
 */
export function konfigurationSchreiben(
  key: string,
  value: unknown,
  rowVersion: number,
): Promise<Konfigurationswert> {
  return anfrage<Konfigurationswert>(`/api/config/${encodeURIComponent(key)}`, {
    methode: "PATCH",
    koerper: { value, rowVersion },
  });
}
